import { apiGet, apiPost, apiPut, parseApiError } from "../utils";

export const getWorldCupNations = async (
  page,
  perPage,
  search = "",
  { sortOrder = "ASC" } = {},
) => {
  const params = { perPage, page, sortOrder };
  if (search) {
    params.search = search;
  }

  const response = await apiGet("/admin/world-cup-nations", params);
  if (!response.ok) {
    await parseApiError(response);
  }
  const { items, totalCount } = await response.json();
  return { items, totalCount };
};

export const createWorldCupNation = async (payload) => {
  const response = await apiPost("/admin/world-cup-nations", payload);
  if (!response.ok) {
    await parseApiError(response);
  }
  return await response.json();
};

export const updateWorldCupNation = async (id, payload) => {
  const response = await apiPut(`/admin/world-cup-nations/${id}`, payload);
  if (!response.ok) {
    await parseApiError(response);
  }
  return await response.json();
};

export const setWorldCupNationStatus = async (id, isActive) => {
  const response = await apiPut(`/admin/world-cup-nations/${id}/status`, {
    isActive,
  });
  if (!response.ok) {
    await parseApiError(response);
  }
  return await response.json();
};
